var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03998 2.29266C2.64921 2.15527 2.22106 2.36068 2.08368 2.75145C1.94629 3.14221 2.1517 3.57036 2.54246 3.70775L2.80367 3.79958C3.47128 4.0343 3.91003 4.18985 4.23288 4.34826C4.5361 4.49704 4.66977 4.61747 4.75783 4.74634C4.84809 4.87842 4.91779 5.05984 4.95712 5.42319C4.99828 5.8034 4.9993 6.29862 4.9993 7.03856L4.9993 9.64024H20.7235C21.054 7.9827 21.2091 7.14067 20.7757 6.57733C20.3318 6.00024 18.815 6.00024 17.1301 6.00024H6.49184C6.48515 5.72991 6.47247 5.48397 6.44841 5.26177C6.39468 4.76539 6.27827 4.31268 5.99629 3.90003C5.71211 3.48417 5.33426 3.21784 4.89363 3.00163C4.48154 2.79943 3.95791 2.61536 3.34138 2.39862L3.03998 2.29266Z",
    fill: "#808084"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1999 12.1881L20.6997 9.76338L20.7242 9.64062H5C5 12.5822 5.06324 13.553 5.92964 14.4668C6.79604 15.3806 8.19049 15.3806 10.9794 15.3806H16.2823C17.8433 15.3806 18.6238 15.3806 19.1755 14.931C19.7273 14.4814 19.8848 13.717 20.1999 12.1881Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z",
    fill: "#808084"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z",
    fill: "#808084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDark);
export default __webpack_public_path__ + "static/media/cart-dark.327e33236aa609a813d2b2228e84be21.svg";
export { ForwardRef as ReactComponent };